<span class="admin-layout">
  <!-- d-none added -->
  <div class="d-none main-content-nav">
    <div>
      <span class="pull-left" style="color: white">
        {{ trainingData.trainingName }}(v{{ trainingData.version }})
      </span>
    </div>
    <div class="userDetails">
      <div>
        <div class="col-sm-12 pull-right">
          <div class="username pull-right">
            {{ userprofilename }}
            <button class="closeButton fa fa-close" (click)="closePreview()"></button>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</span>
<div class="container">
  <!-- d-none added -->
  <div class="d-none row" style="margin: 5px; border-inline-color: 4px solid #0b095e">
    <div class="col-md-3 left-container" style="padding-right: 0px; padding-left: 0px; margin-top: 0px">
      <div class="thumbnail height-card" style="height: 740px">
        <div class="row thumbnail1" style="
            margin-top: 0px;
            background-color: #0b095e;
            border: 2px solid #0b095e;
            margin-left: 0px;
            margin-right: 0px;
          ">
          <div class="col-md-2" style="margin-top: 1px">
            <span style="font-size: 15px; color: white; font-weight: bolder" class="control-labels">Sl.No</span>
          </div>
          <div class="col-md-4" style="margin-top: 1px">
            <span style="font-size: 15px; color: white; font-weight: bolder" class="control-labels">Content</span>
          </div>
          <div class="col-md-3" style="margin-top: 1px">
            <span style="font-size: 15px; color: white; font-weight: bolder" class="control-labels">Time</span>
          </div>
          <div class="col-md-3" style="margin-top: 1px">
            <span style="font-size: 12px; color: #e2f511; font-weight: bolder" class="control-labels">Wait Time</span>
          </div>
        </div>
        <div style="
            overflow-y: auto;
            border-left: 3px solid #0b095e;
            border-right: 3px solid #0b095e;
          " class="item-border"></div>
        <div class="row" *ngFor="let content of contentList; let i = index" style="
            padding-top: 0%;
            padding-right: 0%;
            margin-left: 0%;
            margin-right: 0px;
          ">
          <div class="col-md-12 trainingContent thumbnail1 white-bg-color"
            [ngClass]="{ 'selected-color': varForTickMark == i + 1 }">
            <div style="margin-top: 0%; margin-left: -13px" class="row" (click)="getmoiveLeftMenuUrl(content, i)">
              <div class="col-md-1">
                <span *ngIf="content.status == 'In Progress'"><img src="../../assets/img/In-Progress-null.png" style="
                      max-width: 18px;
                      border-radius: 9px;
                      height: 18px;
                      background-size: cover;
                      display: block;
                      float: left;                     
                    "  alt="" /></span>
                <span *ngIf="content.status == 'Completed'" class="fa fa-check"
                  style="color: green; font-size: 18px"></span>
                <span *ngIf="content.status == 'Failed'" class="fa fa-times" style="color: red; font-size: 18px"></span>
                <span *ngIf="content.status == 'Passed'"><img src="../../assets/img/pass.png" style="
                      max-width: 18px;
                      border: 0px;
                      height: 18px;
                      background-size: cover;
                      display: block;
                      float: left;
                    " alt=""/></span>
                <span *ngIf="content.status == 'Pending' || content.status == null"><img src="../../assets/img/null.png"
                    style="
                      max-width: 18px;
                      border-radius: 9px;
                      height: 18px;
                      background-size: cover;
                      display: block;
                      float: left;
                    " alt="image" /></span>
              </div>
              <div class="col-md-1 control-label">
                <span style="font-size: 12px">{{ content.contentSeq }}</span>
              </div>
              <div class="col-md-4 control-label mouse-ove" style="margin-top: 0%">
                <p class="trainingname text" title="{{ content.contentName }}">
                  {{ content.contentName }}
                </p>
              </div>
              <div class="col-md-3 control-label">
                <span>{{ content.totalDuration }}</span>
              </div>
              <div class="col-md-3 control-label" *ngIf="varForTickMark == i + 1 && !previFirst">
                <span id="timers"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div></div>

      <div class="row paddingRow" style="margin-top: -4%; background-color: #d3d3d3">
        <div class="col-md-12" style="padding-left: 0px">
          <button *ngIf="!firstdisplay" (click)="playfirst()" mat-stroked-button class="text-center" style="
              float: left;
              font-size: 13px;
              background-color: #0b095e;
              color: white;
            ">
            <span class="fa fa-angle-double-left"></span>First
          </button>
          <button *ngIf="!previousdisplay" (click)="playback()" mat-stroked-button class="text-center" style="
              float: left;
              margin-left: 1%;
              font-size: 13px;
              background-color: #0b095e;
              color: white;
            ">
            <span class="fa fa-angle-left"></span>Previous
          </button>
          <button *ngIf="!copmletedisplay" (click)="playLast()" mat-stroked-button class="text-center" style="
              float: right;
              font-size: 13px;
              margin-right: -12px;
              background-color: #0b095e;
              color: white;
            ">
            Last <span class="fa fa-angle-double-right"></span>
          </button>
          <button *ngIf="!copmletedisplay" (click)="playnext(contentList)" mat-stroked-button class="text-center" style="
              float: right;
              margin-right: 1%;
              font-size: 13px;
              background-color: #0b095e;
              color: white;
            ">
            Next <span class="fa fa-angle-right"></span>
          </button>
          <button *ngIf="copmletedisplay && (clickedContent.isQuestionContent === 'Y'
            ? (scoreperc != null &&
               clickedContent.passPercentage != null &&
               scoreperc >= clickedContent.passPercentage)
            : true)" (click)="completetraining(contentList)" mat-stroked-button class="text-center" style="
              float: right;
              margin-right: 1%;
              font-size: 13px;
              background-color: #0b095e;
              color: white;
            ">
            Complete
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-9 right-container" style="padding-right: 0px; padding-left: 5px">
      <div class="contentPlay height-card" style="margin-bottom: 10px; height: 740px; padding: 5px">
        <div class="row" *ngIf="
            clickedContent.contentExtn == 'TXT' ||
            clickedContent.contentExtn == 'txt'
          " style="
            height: 90vh;
            width: 98%;
            border: 20px solid #d5d5d5;
            border-radius: 6px;
          ">
          <div class="col-md-12">
            <iframe id="myIframe" src="" height="85vh" width="100%"
              style="overflow: hidden; height: 85vh; width: 100%"></iframe>
          </div>
        </div>
        <div class="row" *ngIf="
            clickedContent.contentExtn == 'pdf' ||
            clickedContent.contentExtn == 'docx' ||
            clickedContent.contentExtn == 'xlsx' ||
            clickedContent.contentExtn == 'ppt' ||
            clickedContent.contentExtn == 'pptx'
          " style="
            height: 90vh;
            width: 98%;
            border: 20px solid #d5d5d5;
            border-radius: 6px;
          ">
          <div class="col-md-12">
            <web-viewer [data]="viewerData" (oneQmsListener)="onUserActivity()"></web-viewer>
          </div>
        </div>
        <div class="row" *ngIf="clickedContent.contentExtn == 'mp4'" style="
            height: 90vh;
            width: 98%;
            border: 20px solid #d5d5d5;
            border-radius: 6px;
          ">
          <div class="col-md-12">
            <video id="videoarea1" controls="controls" controlsList="nodownload" poster="" src=""
              style="height: 85vh; width: 100%" (play)="onUserActivity()" (pause)="onUserActivity()"
              (timeupdate)="onUserActivity()"></video>
          </div>
        </div>
        <div class="row" *ngIf="clickedContent.contentExtn == 'mp3'" style="
            height: 90vh;
            width: 98%;
            border: 20px solid #d5d5d5;
            border-radius: 6px;
          ">
          <div class="col-md-12">
            <audio controls id="audio1" (play)="onUserActivity()" (pause)="onUserActivity()"
              (timeupdate)="onUserActivity()">
              <source src="" style="width: 100%" />
            </audio>
          </div>
        </div>
        <div class="row" style="padding: 5px" *ngIf="
            clickedContent.contentExtn == 'png' ||
            clickedContent.contentExtn == 'jpeg' ||
            clickedContent.contentExtn == 'PNG' ||
            clickedContent.contentExtn == 'JPEG' ||
            clickedContent.contentExtn == 'JPG' ||
            clickedContent.contentExtn == 'jpg'
          " style="
            height: 90vh;
            width: 98%;
            border: 20px solid #d5d5d5;
            border-radius: 6px;
          ">
          <div class="col-sm-12">
            <img id="picture" src="" height="85vh" width="100%" style="overflow: hidden; height: 85vh; width: 100%" alt=""/>
          </div>
        </div>

        <div class="row" *ngIf="quizdisplay" id="container" class="item-border" style="
            height: 90vh;
            width: 100%;
            border: 20px solid #d5d5d5;
            border-radius: 6px;
          ">

          <div id="myModal" class="modal" style="width: 100vh; max-height: 67px; margin-left: 40%">
            <div class="modal-content">
              <span class="close" style="font-size: 49px; margin-top: -24px" (click)="closeModal()">&times;</span>
              <p style="
                  font-size: 16px;
                  margin-left: 5px;
                  margin-top: 5px;
                  text-align: center;
                ">
                <img src="../../assets/img/info.png" style="width: 20px; height: 20px" alt=""/>
                Not all questions were attempted. Do you want to submit?
              </p>
              <button mat-stroked-button class="text-center addButton"
                style="font-size: 13px; margin-right: 40%; margin-top: -5px" (click)="noBtn()">
                No
              </button>
              <button mat-stroked-button class="text-center cancelButton"
                style="font-size: 13px; margin-right: 1%; margin-top: -5px" (click)="yesBtn()">
                Yes
              </button>
            </div>
          </div>
          <div id="title" class="" style="
              margin-right: -1%;
              background-color: #0b095e;
              font-weight: bolder;
            ">
            <h1 style="
                color: white !important;
                font-size: large;
                margin-top: 15px;
                margin-bottom: 15px;
              ">
              {{ quizName }}
            </h1>
          </div>
          <div *ngIf="isStartPageOfAssessment && !isCompletedPage" style="font-size: 14px">
            <div class="row" style="border: 1px solid gray; border-radius: 10px"
              *ngIf="clickedContent.contentDescription != null">
              <p style="color: gray; display: inline-block; padding-top: 5px">
                Description :
                <span ellipsis-tooltip style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    text-align: justify;
                    font-weight: 400;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2; /* number of lines to show */
                    line-height: 1;
                  ">{{ clickedContent.contentDescription }}</span>
              </p>
            </div>
            <br />
            <div class="row startTestRow" style="margin-left: 1%">
              <div class="col-md-4">
                <div class="">
                  <div class="caption" style="padding: 0px; margin-top: 5%; margin-bottom: 5%">
                    <div class="container">
                      <img *ngIf="trainingData.trainingImage == null" style="width: 70%; height: 0%"
                        src="../../assets/img/exam5icon.png" alt=""/>
                      <img *ngIf="trainingData.trainingImage != null" style="width: 100%" src="data:image/jpg;base64,{{
                          trainingData.trainingImage
                        }}" alt=""/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="row">
                  <div class="col-md-12" style="
                      padding-right: 0px;
                      padding-left: 0px;
                      border: 1px solid #0b095e;
                      height: 165px;
                      margin-top: 2.6%;
                    ">
                    <div class="panel-heading">
                      <h3 class="panel-title" style="color: white">
                        Assessment Details
                      </h3>
                    </div>
                    <div style="padding: 15px">
                      <p style="color: gray">
                        Total No. of Question(s) :
                        <span style="font-weight: 400">{{
                          clickedContent.noOfQuestionsForAssessment
                          }}</span>
                      </p>
                      <p style="color: gray">
                        Passing Criteria :
                        <span style="font-weight: 400">{{ clickedContent.passPercentage }}%</span>
                      </p>
                      <p style="color: gray" *ngIf="noOfAttemptsLeft != 0 && noOfAttemptsLeft != null">
                        No. of Attempt(s) Left :
                        <span style="font-weight: 400">{{
                          noOfAttemptsLeft
                          }}</span>
                      </p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <br />
            <div class="row pull-right">
              <button mat-stroked-button style="color: black; background-color: #9bcff2" (click)="startTheTest()">
                Begin Assessment
              </button>
            </div>
          </div>
          <div *ngIf="isDisplayOfQuestionsPages">
            <app-quiz [questions]="questionDataOfAssessment" [clickedContent]="clickedContent"
              [questionCounter]="questionCounter" (onAllSubmit)="onAllSubmit($event)"></app-quiz>
          </div>
          <div *ngIf="isPreviewPage" style="overflow-y: scroll">
            <div class="row" *ngFor="let question of questionDataOfAssessment; let i = index"
              style="font-weight: 400 !important">
              <p style="margin-bottom: 5px" class="content-que-label">
                {{ i + 1 }}.
                <span *ngIf="
                    question.question != 'undefined' &&
                    question.question != '' &&
                    question.question != null &&
                    question.question != 'null'
                  ">{{ question.question }}</span>
              </p>
              <div class="row" *ngIf="
                  question.questionImage != null &&
                  question.questionImage != '' &&
                  question.questionImage != 'undefined' &&
                  question.questionImage != 'null'
                ">
                <img id="assessmentImageId" src="data:image/png;base64,{{ question.questionImage }}"
                  style="width: 50px; height: 50px" (click)="imageClick(question.questionImage)" />
              </div>

              <div style="margin-left: 1%" class="row" *ngIf="
                  question.questionType == 'CHECKBOX' ||
                  question.questionType == 'Check Box'
                ">
                <div *ngFor="let answOptions of question.questionOptions">
                  <label class="content-opt-label">{{ answOptions.optionCode }}.
                    <input type="checkbox" [(ngModel)]="answOptions.answer"
                      [checked]="answOptions.answer == answOptions.correctAnswer" style="
                        margin-left: 5px;
                        width: 15px !important;
                        height: 15px !important;
                        margin-top: 3px !important;
                      " />
                    <span ng-if="
                        answOptions.optionValue != 'undefined' &&
                        answOptions.optionValue != '' &&
                        answOptions.optionValue != null &&
                        answOptions.optionValue != 'null'
                      ">{{ answOptions.optionValue }}</span>
                  </label>
                  <div class="row" *ngIf="
                      answOptions.optionImage != 'null' &&
                      answOptions.optionImage != null &&
                      answOptions.optionImage != '' &&
                      answOptions.optionImage != 'undefined'
                    ">
                    <img id="assessmentImageId" src="data:image/png;base64,{{ answOptions.optionImage }}"
                      style="width: 50px; height: 50px" (click)="imageClick(answOptions.optionImage)" alt="" />
                  </div>
                </div>
              </div>
              <div style="margin-left: 1%" class="row" *ngIf="
                  question.questionType == 'RADIO' ||
                  question.questionType == 'Radio Button'
                ">
                <div *ngFor="let answOptions of question.questionOptions">
                  <label class="content-opt-label">{{ answOptions.optionCode }}.
                    <input type="radio" [(ngModel)]="answOptions.selectedAnswer"
                      [checked]="answOptions.selectedAnswer  == answOptions.correctAnswer" style="
                        margin-left: 5px;
                        width: 15px !important;
                        height: 15px !important;
                        margin-top: 3px !important;
                      " value="{{ answOptions.optionCode }}" /><span ng-if="
                        answOptions.optionValue != 'undefined' &&
                        answOptions.optionValue != '' &&
                        answOptions.optionValue != null &&
                        answOptions.optionValue != 'null'
                      ">{{ answOptions.optionValue }}</span></label>
                  <div class="row" *ngIf="
                      answOptions.optionImage != 'null' &&
                      answOptions.optionImage != null &&
                      answOptions.optionImage != '' &&
                      answOptions.optionImage != 'undefined'
                    ">
                    <img id="assessmentImageId" src="data:image/png;base64,{{ answOptions.optionImage }}"
                      style="width: 50px; height: 50px" (click)="imageClick(answOptions.optionImage)" />
                  </div>
                </div>
              </div>
              <span *ngIf="question.assessmentStatus == 'Correct'" class="fa fa-check"
                style="color: green; font-size: 10px; margin-left: 1%">Correct Answer</span>
              <span *ngIf="question.assessmentStatus == 'Wrong'" class="fa fa-times"
                style="color: red; font-size: 10px; margin-left: 1%">Wrong Answer</span>
              <p *ngIf="trainingData.showAnswersAtReview == 'Y'" style="margin-left: 1%; margin-bottom: 5px"
                class="content-que-label">
                Correct Answer : {{ question.answer }}
              </p>

              <hr />
            </div>
            <div style="text-align: center; margin-top: 20px; color: #5193cc">
              <button (click)="goBack()" class="btn btn-primary text-center" style="font-size: 13px">
                Back
              </button>
            </div>
            <br />
          </div>
          <div *ngIf="isCompletedPage">
            <div class="row" *ngIf="scoreperc < clickedContent.passPercentage">
              <div class="col-md-12" style="
                  padding-right: 0px;
                  padding-left: 0px;
                  border: 1px solid #0b095e;
                  height: 165px;
                  margin-top: 2.6%;
                ">
                <div class="panel-heading">
                  <h3 class="panel-title" style="color: white">Result</h3>
                </div>
                <div style="padding: 15px; text-align: center">
                  <p style="color: red; margin-bottom: 0px; font-size: 16px">
                    Sorry!
                  </p>
                  <p style="color: red; margin-bottom: 0px; font-size: 16px">
                    You did not clear the assessment
                  </p>
                  <p style="color: gray; margin-bottom: 0px">
                    Please click on Retake Assessment to continue the training.
                  </p>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="scoreperc >= clickedContent.passPercentage">
              <div class="col-md-12" style="
                  padding-right: 0px;
                  padding-left: 0px;
                  border: 1px solid #0b095e;
                  margin-top: 2.6%;
                ">
                <div class="panel-heading">
                  <h3 class="panel-title" style="color: white">Result</h3>
                </div>
                <div style="padding: 15px; text-align: center">
                  <p style="color: green; margin-bottom: 0px; font-size: 16px">
                    Congratulation!
                  </p>
                  <p style="color: green; margin-bottom: 0px; font-size: 16px">
                    You have completed the assessment
                  </p>
                  <p style="color: gray; margin-bottom: 0px">
                    Please click on complete to close the training.
                  </p>
                </div>
              </div>
            </div>
            <br />
            <div class="row" style="margin-bottom: 1%">
              <div class="col-md-12 text-center">
                <button style="background-color: #f2f2f2; float: none" mat-stroked-button>
                  Number of Questions :
                  {{ clickedContent.noOfQuestionsForAssessment }}
                </button>

              </div>
            </div>
            <div class="row" style="margin-bottom: 1%">
              <div class="col-md-12 text-center">
                <button style="
                    background-color: #f2f2f2;
                    float: none;
                    margin-right: 3%;
                  " mat-stroked-button>
                  Correct Answers : {{ noofCorrectAnsw }}
                </button>
                <button style="background-color: #f2f2f2; float: none" mat-stroked-button>
                  Wrong Answers : {{ noofWrongAnsw }}
                </button>
              </div>
            </div>
            <div class="row" style="margin-bottom: 1%">
              <div class="col-md-12 text-center">
                <button style="
                    background-color: #f2f2f2;
                    float: none;
                    margin-right: 3%;
                  " mat-stroked-button>
                  Scored Percentage : {{ scoreperc }}%
                </button>
                <button style="background-color: #f2f2f2; float: none" mat-stroked-button>
                  Pass Percentage : {{ clickedContent.passPercentage }}%
                </button>
              </div>
            </div>
            <hr />
            <div class="row" style="margin-bottom: 1%; margin-top: 2%">
              <div class="col-md-12 text-center">
                <button *ngIf="trainingData.allowToReviewResults == 'Y'" mat-stroked-button style="
                    background-color: #fbe5d6;
                    float: none;
                    margin-right: 3%;
                  " (click)="reviewAnswer()">
                  Review Answers
                </button>
                <button *ngIf="scoreperc < 100" mat-stroked-button style="background-color: #fbe5d6; float: none"
                  (click)="retakeAssessment()">
                  Retake Assessment
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-center">
                <button *ngIf="copmletedisplayForAssessment && (clickedContent.isQuestionContent === 'Y'
            ? (scoreperc != null &&
               clickedContent.passPercentage != null &&
               scoreperc >= clickedContent.passPercentage)
            : true)" mat-stroked-button style="background-color: #fbe5d6; float: none"
                  (click)="completetraining(contentList)">
                  Complete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex">
    <div [hidden]="isDisplayOfQuestionsPages || isPreviewPage" class="content_menu">
      <h5 class="training_text content_title fw-medium">
        {{ trainingData.trainingCode }}
      </h5>
      <div>
        <p class="training_text progress_text mb-2">Progress: {{progress}}%</p>
        <div class="progress_bar">
          <div [ngStyle]="{'background-color': '#005c8a', 'width': progress+'%','height': '8px'}"></div>
        </div>
      </div>
      <h5 class="training_text content_title text-center my-3">
        Training Contents
      </h5>
      <div class="d-flex my-3 justify-content-between align-items-center">
        <div class="dropdown">
          <button class="btn training_text fw-medium all_dropdown border-0 outline-0 dropdown-toggle px-2" type="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            All

          </button>

        </div>
        <p class="progress_text training_text fw-medium">{{contentList.length}} Modules</p>
      </div>
      <div>
        <!-- active class is added -->
        <div class="content-list-container">
          <div class="mb-3 contents" *ngFor="let content of contentList,let i=index;"
            [class.active]="i+1 == clickedContent.contentSeq">
            <div class="d-flex gap-2">
              <img *ngIf="content.status == 'Completed'" src="../../assets/img/cr_module/green_tick.svg" width="20px"
                height="20px" alt="check mark" />
              <img *ngIf="content.contentExtn =='mp4'" src="../../assets/img/training_module/video.svg" width="20px"
                height="20px" alt="video" />
              <img *ngIf="content.contentExtn =='mp3'" src="../../assets/img/training_module/audio.svg" width="20px"
                height="20px" alt="video" />
              <img *ngIf="content.contentExtn =='ppt' || content.contentExtn =='pptx'"
                src="../../assets/img/training_module/presentation.svg" width="20px" height="20px" alt="presentation" />
              <img *ngIf="content.contentExtn =='pdf'" src="../../assets/img/training_module/pdf.svg" width="20px"
                height="20px" alt="presentation" />
              <img *ngIf="content.contentExtn =='docx' || content.contentExtn =='xlsx'
            || content.contentExtn =='txt' || content.contentExtn =='TXT'"
                src="../../assets/img/training_module/Tab - Files.svg" width="20px" height="20px" alt="presentation" />
              <img *ngIf="content.contentExtn ==null" src="../../assets/img/training_module/Test.svg" width="20px"
                height="20px" alt="presentation" />
              <p class="training_text">
                <span class="fw-medium" *ngIf="content.contentExtn =='mp4'">Video: </span>
                <span class="fw-medium" *ngIf="content.contentExtn =='mp3'">Audio: </span>
                <span class="fw-medium" *ngIf="content.contentExtn =='pdf' || content.contentExtn =='docx' || content.contentExtn =='xlsx'
              || content.contentExtn =='txt' || content.contentExtn =='TXT'"></span>
                <span class="fw-medium"
                  *ngIf="content.contentExtn =='ppt' || content.contentExtn =='pptx'">Presentation: </span>
                {{content.contentName}}
              </p>
            </div>
            <p class="training_text duration mt-1">{{content.totalDuration}}</p>
            <p class="training_text duration" *ngIf="varForTickMark == i+1 && !previFirst"><span style="color: red;"
                id="timers1"></span></p>
          </div>
        </div>
      </div>
    </div>
    <div class="right_container">
      <div class="alert-danger" *ngIf="alertShow" style="margin-right: 41%; font-size: 18px">
        <img src="../../assets/img/info.png" style="
          width: 20px;
          margin-top: 2px;
          border-radius: 9px;
          height: 20px;
          background-size: cover;
          display: block;
          float: left;
        " alt=""/>&nbsp;
        {{ alertMsg }}
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <div *ngIf="isDisplayOfQuestionsPages  || isPreviewPage"
          class="d-flex justify-content-between align-items-center assessment_top_menu">
          <div class="d-flex gap-5">
            <span class="training_text content_title fw-medium">
              {{ trainingData.trainingName }} : {{clickedContent.contentName}}
            </span>
          </div>
          <div class="d-flex gap-1 me-3">
            <div *ngIf="clickedContent.totalDuration != null">
              <p class="training_text time">Time</p>
              <p class="training_text all_dropdown">{{clickedContent.totalDuration}}</p>
            </div>
          </div>
        </div>

        <h5 *ngIf="!isDisplayOfQuestionsPages  && !isPreviewPage" class="training_text content_title fw-medium">
          {{ trainingData.trainingName }}
        </h5>
        <div class="d-flex navbar_shadow p-2">
          <div class="notification_bg rounded-3 position-relative p-1" style="margin-top: 5px;cursor: pointer;"
            (click)="openNotifications()">
            <svg width="28" height="28" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path _ngcontent-ng-c2569100152=""
                d="M3.14999 4.9501L8.4877 8.64544C8.7959 8.85881 9.20408 8.85881 9.51228 8.64544L14.85 4.9501M3.59999 14.4001H14.4C15.3941 14.4001 16.2 13.5942 16.2 12.6001V5.4001C16.2 4.40599 15.3941 3.6001 14.4 3.6001H3.59999C2.60588 3.6001 1.79999 4.40599 1.79999 5.4001V12.6001C1.79999 13.5942 2.60588 14.4001 3.59999 14.4001Z"
                stroke="#005C8A" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <span class="badge_position p-1 bg-danger border-0 rounded-circle">
              <span class="visually-hidden">New alerts</span>
            </span>
          </div>
          <div class="d-flex px-2">
            <div class="me-2">
              <span *ngIf="oneQmsOrgUsersDetails == null || oneQmsOrgUsersDetails == undefined">
                <i class="fa-regular fa-circle-user userimg" style="font-size: 33px;"></i>
              </span>
              <span *ngIf="oneQmsOrgUsersDetails != null || oneQmsOrgUsersDetails != undefined">
                <img class="userimg" src="data:image/*;base64,{{oneQmsOrgUsersDetails.userImage}}" width="45"
                  height="40" alt="" />
              </span>
            </div>
            <div class="dropdown">
              <button *ngIf="userDetails!=null&&userDetails!=undefined"
                class="btn border-0 outline-0 dropdown-toggle px-1" type="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                {{userDetails.userNameAtApplication}}
              </button>
            </div>
            <div class="d-flex justify-content-center align-items-center actions_cta cancel_cta"
              (click)="closePreview()">
              <img src="../../assets/img/cr_module/cancel.svg" width="9px" height="9px" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class=" col-md-6 d-flex justify-content-start gap-3">
          <div *ngIf="!firstdisplay && !isDisplayOfQuestionsPages && !isPreviewPage"
            class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="playfirst()">
            <img src="../../assets/img/training_module/Button Arrow Left white.svg" width="18px" height="18px"
              alt="First" />
            <span class="reload_text text-white">First</span>
          </div>
          <div *ngIf="!previousdisplay && !isDisplayOfQuestionsPages  && !isPreviewPage"
            class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="playback()">
            <img src="../../assets/img/training_module/Button Arrow Left white.svg" width="18px" height="18px"
              alt="Previous" />
            <span class="reload_text text-white">Previous</span>
          </div>
          <div *ngIf="!previousdisplay && (isDisplayOfQuestionsPages || isPreviewPage)" (click)="playback()"
            class="addIconContiner d-flex gap-2 justify-content-center align-items-center">
            <span class="reload_text text-white">View Previous Content</span>
          </div>
        </div>
        <div class="col-md-6 d-flex justify-content-end gap-3">
          <div *ngIf="!copmletedisplay && !isDisplayOfQuestionsPages  && !isPreviewPage" (click)="playLast()"
            class="addIconContiner d-flex gap-2 justify-content-center align-items-center">
            <img src="../../assets/img/training_module/Button Arrow Right White.svg" width="18px" height="18px"
              alt="Last" />
            <span class="reload_text text-white">Last</span>
          </div>
          <div *ngIf="!copmletedisplay && !isDisplayOfQuestionsPages && !isPreviewPage" (click)="playnext(contentList)"
            class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            [class.disabled]="!isTimerActive">
            <img src="../../assets/img/training_module/Button Arrow Right White.svg" width="18px" height="18px"
              alt="Next" />
            <span class="reload_text text-white">Next</span>
          </div>
          <div *ngIf="!copmletedisplay && (isDisplayOfQuestionsPages  || isPreviewPage)" (click)="playnext(contentList)"
            class="addIconContiner d-flex gap-2 justify-content-center align-items-center">

            <span class="reload_text text-white">View Next Content</span>
          </div>
          <div *ngIf="isPreviewPage" (click)="goBack()"
            class="addIconContiner d-flex gap-2 justify-content-center align-items-center" style="cursor: pointer;">
            <img src="../../assets/img/training_module/Button Arrow Left white.svg" width="18px" height="18px"
              alt="Back" />
            <span class="reload_text text-white">Back</span>
          </div>
          <div *ngIf="copmletedisplay && !isPreviewPage && (clickedContent.isQuestionContent === 'Y'
            ? (scoreperc != null &&
               clickedContent.passPercentage != null &&
               scoreperc >= clickedContent.passPercentage)
            : true)" (click)="completetraining(contentList)"
            class="addIconContiner d-flex gap-2 justify-content-center align-items-center">

            <span class="reload_text text-white">Complete</span>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <div>
          <div class="" *ngIf="
              clickedContent.contentExtn == 'TXT' ||
              clickedContent.contentExtn == 'txt'
            ">
            <div class="">
              <iframe id="myIframe" src="" height="604px" width="100%"
                style="overflow: hidden; height: 604px; width: 100%"></iframe>
            </div>
          </div>
          <div class="" *ngIf="
              clickedContent.contentExtn == 'pdf' ||
              clickedContent.contentExtn == 'docx' ||
              clickedContent.contentExtn == 'xlsx' ||
              clickedContent.contentExtn == 'ppt' ||
              clickedContent.contentExtn == 'pptx'
            ">
            <div style="height: 604px">
              <web-viewer [data]="viewerData" (oneQmsListener)="onUserActivity()"></web-viewer>
            </div>
            <div>
              <div class="mt-2">
                <span class="progress_text training_text text-black fw-semibold">Overview</span>
                <div class="overview_underline">
                  <span class="overview_highlight"></span>
                </div>
              </div>
              <div>
                <h3 class="intro_text mt-4 mb-3">
                  {{clickedContent.contentName}}
                </h3>
                <p class="training_text all_dropdown lh-base">
                  {{clickedContent.contentDescription}}
                </p>
              </div>
            </div>
          </div>
          <div class="" *ngIf="clickedContent.contentExtn == 'mp4'">
            <div class="">
              <video autoplay id="videoarea" controls="controls" controlsList="nodownload" poster=""
                style="height: 604px; width: 100%;" (play)="onUserActivity()" (pause)="onUserActivity()"
                (timeupdate)="onUserActivity()">
                <source src="">
              </video>
            </div>
            <div>
              <div class="mt-2">
                <span class="progress_text training_text text-black fw-semibold">Overview</span>
                <div class="overview_underline">
                  <span class="overview_highlight"></span>
                </div>
              </div>
              <div>
                <h3 class="intro_text mt-4 mb-3">
                  {{clickedContent.contentName}}
                </h3>
                <p class="training_text all_dropdown lh-base">
                  {{clickedContent.contentDescription}}
                </p>
              </div>
            </div>
          </div>
          <div class="" *ngIf="clickedContent.contentExtn == 'mp3'">
            <div>
              <div class="audio_bg">
                <img src="../../assets/img/training_module/audio_bg.png" width="100%" height="604px"
                  alt="audio background image" />
              </div>
              <div class="loader">
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
              </div>
              <div class="audio_file">
                <audio controls id="audio" (play)="onUserActivity()" (pause)="onUserActivity()"
                  (timeupdate)="onUserActivity()">
                  <source src="" />
                </audio>
              </div>
            </div>
            <div>
              <div class="mt-2">
                <span class="progress_text training_text text-black fw-semibold">Overview</span>
                <div class="overview_underline">
                  <span class="overview_highlight"></span>
                </div>
              </div>
              <div>
                <h3 class="intro_text mt-4 mb-3">
                  {{clickedContent.contentName}}
                </h3>
                <p class="training_text all_dropdown lh-base">
                  {{clickedContent.contentDescription}}
                </p>
              </div>
            </div>
          </div>
          <div class="row" style="padding: 5px" *ngIf="
              clickedContent.contentExtn == 'png' ||
              clickedContent.contentExtn == 'jpeg' ||
              clickedContent.contentExtn == 'PNG' ||
              clickedContent.contentExtn == 'JPEG' ||
              clickedContent.contentExtn == 'JPG' ||
              clickedContent.contentExtn == 'jpg'
            ">
            <div class="col-sm-12">
              <img id="picture" src="" height="85vh" width="100%" style="overflow: hidden; height: 85vh; width: 100%" />
            </div>
          </div>
          <div class="row" *ngIf="quizdisplay" id="container" class="item-border" style="height: 90vh;">

            <div id="myModal" class="modal" style="width: 100vh; max-height: 67px; margin-left: 40%">
              <div class="modal-content">
                <span class="close" style="font-size: 49px; margin-top: -24px" (click)="closeModal()">&times;</span>
                <p style="
                    font-size: 16px;
                    margin-left: 5px;
                    margin-top: 5px;
                    text-align: center;
                  ">
                  <img src="../../assets/img/info.png" style="width: 20px; height: 20px" />
                  Not all questions were attempted. Do you want to submit?
                </p>
                <button mat-stroked-button class="text-center addButton"
                  style="font-size: 13px; margin-right: 40%; margin-top: -5px" (click)="noBtn()">
                  No
                </button>
                <button mat-stroked-button class="text-center cancelButton"
                  style="font-size: 13px; margin-right: 1%; margin-top: -5px" (click)="yesBtn()">
                  Yes
                </button>
              </div>
            </div>
            <div id="title" class="">
            </div>
            <div *ngIf="isStartPageOfAssessment && !isCompletedPage">
              <div class="" *ngIf="clickedContent.contentDescription != null">
                <p class="training_text all_dropdown fw-semibold">
                  Description
                </p>
                <p ellipsis-tooltip class="training_text all_dropdown mt-2 lh-base">{{ clickedContent.contentDescription
                  }}</p>
              </div>
              <br />
              <div class="">
                <div class="">
                  <div class="">
                    <div class="">
                      <div>
                        <h3 class="training_text all_dropdown fw-semibold mt-4">
                          Assessment Details
                        </h3>
                      </div>
                      <div>
                        <p class="training_text all_dropdown mt-2">
                          Total Number of Question(s):
                          <span>{{
                            clickedContent.noOfQuestionsForAssessment
                            }}</span>
                        </p>
                        <p class="training_text all_dropdown mt-2">
                          Passing Criteria :
                          <span>{{ clickedContent.passPercentage }}%</span>
                        </p>
                        <p class="training_text all_dropdown mt-2"
                          *ngIf="trainingData.remainingAttempts != 9999 && trainingData.remainingAttempts != null">
                          No. of Attempt(s) Left :
                          <span>{{
                            trainingData.remainingAttempts
                            }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div class="">
                <button class="training_text all_dropdown assessment_cta" mat-stroked-button (click)="startTheTest()">
                  Begin Assessment
                </button>
              </div>
            </div>
            <div *ngIf="isDisplayOfQuestionsPages">
              <app-quiz [questions]="questionDataOfAssessment" [clickedContent]="clickedContent"
                [questionCounter]="questionCounter" (onAllSubmit)="onAllSubmit($event)"></app-quiz>
            </div>
            <div *ngIf="isPreviewPage" style="overflow-y: scroll">
              <div class="d-flex gap-5">
                <div style="flex: 2">
                  <div class="">
                    <div class="" *ngFor="let question of questionDataOfAssessment; let i = index">
                      <div class="question_container">
                        <div class="questions">
                          <span class="question_number fw-medium">
                            Q. {{ i + 1 }}/{{ questionDataOfAssessment.length }}
                          </span>
                        </div>
                        <p class="question_number ps-4 py-2">
                          {{ question.question }}
                        </p>
                        <div class="ps-4 pb-2 imgPopup" *ngIf="question.questionImage != null">
                          <img src="data:image/png;base64,{{
                              question.questionImage
                            }}" style="width: 300px; height: 300px" alt="" />
                        </div>
                      </div>
                      <div class="options">
                        <div class="" style="margin-top: 2%">
                          <div class="">
                            <div *ngIf="question.assessmentStatus == 'Correct'" class="options_block1">
                              <div class="ps-4 py-2">
                                <img src="../../assets/img/training_module/correctAnswer.svg" height="18" width="18" alt="" />
                                &nbsp;&nbsp;Correct
                              </div>
                            </div>
                            <div *ngIf="question.assessmentStatus == 'Wrong'" class="options_block2">
                              <div class="ps-4 py-2">
                                <img src="../../assets/img/training_module/wrongAnswer.svg" height="18" width="18">
                                &nbsp;&nbsp;Wrong
                              </div>
                            </div>
                            <div class="table-borderless" style="overflow-x: hidden">
                              <div *ngFor="let option of question?.questionOptions; let i = index">
                                <div *ngIf="
                            question?.questionType == 'Radio Button' ||
                            question?.questionType == 'RADIO'
                          " class="options_block">

                                  <div class="ps-4 py-2">
                                    <mat-radio-button class="tp-radio-button" [name]="'Radio' + question.questionId"
                                      [value]="option?.optionCode" [checked]="option.checked"
                                      [(ngModel)]="option.answer" [disabled]="true">
                                      <span class="text-black fw-normal">{{ option.optionCode }}. {{
                                        option.optionValue
                                        }}</span>
                                    </mat-radio-button>
                                  </div>
                                </div>
                                <div *ngIf="
                            question?.questionType == 'Check Box' ||
                            question?.questionType == 'CHECKBOX'
                          " class="options_block">
                                  <div class="ps-4 py-2">
                                    <mat-checkbox [name]="option?.optionCode" [checked]="option.checked"
                                      [value]="option?.optionCode" [(ngModel)]="option.answer" [disabled]="true">
                                      <span class="text-black fw-normal">{{ option.optionCode }}. {{
                                        option.optionValue
                                        }}</span></mat-checkbox>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!---->
                      </div>

                      <p *ngIf="trainingData.showAnswersAtReview == 'Y'" style="margin-left: 1%; margin-bottom: 5px"
                        class="content-que-label">
                        Correct Answer : {{ question.answer }}
                      </p>

                      <hr />

                    </div>

                  </div>

                </div>
              </div>
              <div class="d-flex gap-3 justify-content-end mt-5">
                <div (click)="goBack()" class="addIconContiner d-flex gap-2 justify-content-center align-items-center">
                  <span class="reload_text text-white">Back</span>
                </div>
              </div>

              <br />
            </div>


            <div *ngIf="isCompletedPage">
              <div class="" *ngIf="clickedContent.contentDescription != null">
                <p class="training_text all_dropdown fw-semibold">
                  Description
                </p>
                <p ellipsis-tooltip class="training_text all_dropdown mt-2 lh-base">{{ clickedContent.contentDescription
                  }}</p>
              </div>
              <br />
              <div class="">
                <div class="">
                  <div class="">
                    <div class="">
                      <div>
                        <h3 class="training_text all_dropdown fw-semibold mt-4">
                          Assessment Details
                        </h3>
                      </div>
                      <div>
                        <p class="training_text all_dropdown mt-2">
                          Total Number of Question(s):
                          <span>{{
                            clickedContent.noOfQuestionsForAssessment
                            }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br><br>
              <div class="menu-container" style="margin-top: 2%;">
                <div class="row menu-row-container">
                  <div class="col-sm-8 gridName-container">
                    <span class="gridName">Assessment Result</span>
                  </div>
                </div>
              </div>
              <div class="row mt-2" *ngIf="scoreperc < clickedContent.passPercentage">
                <div class="col-md-12 errorBanner" style="padding: 0px;">
                  <span><img style="width: 100%;" src="../../assets/img/training_module/fail_back.svg" alt="" /></span>
                  <span class="insideBanner"><img src="../../assets/img/training_module/passfailback.svg" alt="" /></span>
                  <p class="retakeTimer" [hidden]="!showRetakeTime">
                    <span style="color: white;font-size: 11px;">Retake Wait Time</span><br>
                    <span style="color: white;" id="timers2"></span>
                  </p>
                  <div style="position: absolute;bottom: 35%;left: 5%;">
                    <p style="color: white;line-height:30px;font-size: 20px;font-weight: 500;">
                      Sorry
                    </p>
                    <p style="color: white; margin-bottom: 0px; font-size: 16px">
                      You did not clear the assessment
                    </p>
                    <p style="color: white; margin-bottom: 0px; font-size: 12px">
                      Please click on complete to close training
                    </p>
                  </div>
                </div>
              </div>
              <div class="row mt-2" *ngIf="scoreperc >= clickedContent.passPercentage">
                <div class="col-md-12 errorBanner" style="padding: 0px;">
                  <span><img style="width: 100%;" src="../../assets/img/training_module/pass_back.svg"></span>
                  <span class="insideBanner"><img src="../../assets/img/training_module/passfailback.svg"></span>
                  <div style="position: absolute;bottom: 35%;left: 5%;">
                    <p style="color: white;line-height:30px;font-size: 20px;font-weight: 500;">
                      Congratulation!
                    </p>
                    <p style="color: white; margin-bottom: 0px; font-size: 16px">
                      You have passed the assessment
                    </p>
                    <p style="color: white; margin-bottom: 0px; font-size: 12px">
                      Please click on complete to close training
                    </p>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="d-flex justify-content-start mt-4">
                    <div>
                      <p style="font-size: 14px;font-weight: 500;"> Correct Answer</p>
                      <span style="font-size: 14px;font-weight: 400;">{{ noofCorrectAnsw }}</span>
                    </div>
                    <div style="margin-left: 12%;">
                      <p style="font-size: 14px;font-weight: 500;"> Wrong Answer</p>
                      <span style="font-size: 14px;font-weight: 400;">{{ noofWrongAnsw }}</span>
                    </div>

                  </div>
                  <div class="d-flex justify-content-start mt-4">
                    <div>
                      <p style="font-size: 14px;font-weight: 500;"> Scored Percentage</p>
                      <span style="font-size: 14px;font-weight: 400;">{{ scoreperc }} %</span>
                    </div>
                    <div style="margin-left: 8%;">
                      <p style="font-size: 14px;font-weight: 500;">Pass Percentage</p>
                      <span style="font-size: 14px;font-weight: 400;">{{ clickedContent.passPercentage }} %</span>
                    </div>

                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex justify-content-end mt-4">
                    <div *ngIf="trainingData.allowToReviewResults == 'Y'" (click)="reviewAnswer()"
                      class="addIconContiner d-flex gap-2 justify-content-center align-items-center">
                      <span class="reload_text text-white">Review Answers</span>
                    </div>
                    <div (click)="retakeAssessment()" *ngIf="!showRetakeTime && scoreperc < 100"
                      class="addIconContiner d-flex gap-2 justify-content-center align-items-center">
                      <span class="reload_text text-white">Retake Assessment</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end mt-4">
                    <div *ngIf="copmletedisplayForAssessment && (clickedContent.isQuestionContent === 'Y'
            ? (scoreperc != null &&
               clickedContent.passPercentage != null &&
               scoreperc >= clickedContent.passPercentage)
            : true)" (click)="completetraining(contentList)"
                      class="addIconContiner d-flex gap-2 justify-content-center align-items-center">
                      <span class="reload_text text-white">Complete</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #modalConfirmPopup>
    <div class="page-loading-shade" >
      <app-custom-spinner ></app-custom-spinner>
    </div>
    <h2 mat-dialog-title>Confirmation</h2>
    <div style="margin: 15px 15px">
      <div class="form-continer">
        <div class="row">
          <div class="col-md-12">
            Not all questions were attempted. Do you want to submit?
          </div>
        </div>
        <br />
      </div>
      <div class="button-continer" mat-dialog-actions class="btn-align">
        <button mat-stroked-button class="deleteButton" (click)="yesBtn()">
          Yes
        </button>
        <button mat-stroked-button class="cancelButton" (click)="noBtn()">
          No
        </button>
      </div>
    </div>
  </ng-template>
  <ng-template #confirmationPopup>
    <div class="page-loading-shade" >
      <app-custom-spinner ></app-custom-spinner>
    </div>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Confirmation</label>
      <label class="popupAppTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <div>
      <div class="form-continer">
        <div class="row">
          <div class="col-md-12">
            <div id="filed-container" class="form-continer" style="height: auto">
              <div class="row">
                <span style="color: green">{{
                  trainingCompleteConfirmationMsg
                  }}</span>
              </div>
              <div class="row text-center" style="margin-top: 2%">
                <a href="" (click)="openPopup($event)"> View Certificate</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="button-continer" mat-dialog-actions class="btn-align">
        <button mat-stroked-button class="addButton" (click)="backToPageWithConfirm()">
          OK
        </button>
      </div>
    </div>
  </ng-template>
  <ng-template #confirmCompletePopup>
    <div class="page-loading-shade" >
      <app-custom-spinner ></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelCompleteFunc()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Complete Training</label>
      <label class="popupAppTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <div>
      <div class="form-continer">
        <div class="row">
          <div class="col-md-12">
            <div style="height: auto; margin-top: 10px">
              <div class="row">
                <div class="col-md-3">
                  <label for="username ">User Name</label><span class="mandatory-symbol">*</span>
                </div>
                <div class="col-md-9">
                  <input id="username" style="height: 80% !important" class="input-filed-continers" type="text"
                    [(ngModel)]="displayUserName" disabled />
                </div>
              </div>
              <div class="row" *ngIf="isEsignRequired && !isAdEnabled">
                <div class="col-md-3">
                  <label for="pass ">Password</label><span class="mandatory-symbol">*</span>
                </div>
                <div class="col-md-9">
                  <input id="pass" style="height: 80% !important" class="input-filed-continers"
                    [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password" noCopyPaste />
                  <span class="eyeicon-container eye-color" (click)="showPassword()">
                    <i
                      [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
                  </span>
                </div>
                <span style="margin-left: 25%" id="pass-required-msg">Please enter password</span>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <label for="reasonForSign">Reason For Signature<span class="mandatory-symbol">*</span></label>
                </div>
                <div class="col-md-9">
                  <mat-select id="rejectReason" matInput placeholder="Select" [(ngModel)]="reasonForSign"
                    (closed)="reasonSearchText=''" (click)="focusSearch('focus-reason-search')">

                    <input type="search" id="focus-reason-search" class="dropdownsearchstyle"
                      [(ngModel)]="reasonSearchText" matInput placeholder="search">

                    <mat-option class="unselectStyle" [value]="null"
                      (onSelectionChange)="onReasonSelect($event,null)">Un-select</mat-option>

                    <mat-option *ngFor="let item of reasonForSignatureList | assessmentSearch : reasonSearchText"
                      [value]="item.reasonForSignature" (onSelectionChange)="onReasonSelect($event,item)">
                      {{ item.reasonForSignature }}
                    </mat-option>
                  </mat-select>

                  <span id="reasonFor-required-msg">Please select a reason</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
      <div class="button-continer" mat-dialog-actions class="btn-align">
        <button mat-stroked-button class="addButton" (click)="confirmComplete()">
          Complete
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelCompleteFunc()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </ng-template>
  <ng-template #certificationPopup>
    <div class="ng-template-container" style="background-color: #f9f7f2;">
      <i class="fa fa-close pull-right" style="cursor: pointer;" title="Close" (click)="cancelCer()"></i>
      <i class="fa fa-download pull-right" style="cursor: pointer;" title="Download" (click)="downloadAsPdf()"></i>
      <div id="dataToExport" class="row" *ngIf="!isDefaultTemplate">
        <div class="col-md-10" style="margin-top: 2%;padding-left: 4%;margin-bottom: 2%;">
          <div class="row text-center">
            <span>
              <img *ngIf="oneQmsOrgImagesDetails.logoImage != null" class="org-image"
                src="data:image/*;base64,{{oneQmsOrgImagesDetails.logoImage}}" style="width: 60px;height: 60px;">
              <span style="display: inline-flex;width: 40%;">{{orgData.orgLongName}}</span>
            </span>
          </div>
          <br>
          <div class="row text-center">
            <span class="cetificateTitle">Certificate of Completion</span>

          </div>
          <div class="row text-center" style="margin-top: 2%;">
            <span style="color: gray;font-weight: 500;"><i>This is to certify that</i></span>
          </div>
          <div class="row text-center" style="margin-top: 2%;">
            <span style="font-weight: 600;">{{userDetails.userNameAtApplication}}</span>
          </div>
          <div class="row text-center" style="margin-top: 2%;">
            <span style="color: gray;font-weight: 500;"><i>Has successfully completed the {{trainingData.type}}
                course</i></span>
          </div>
          <div class="row text-center" style="margin-top: 2%;">
            <span style="font-weight: 600;">{{trainingData.trainingName}}</span>
          </div>
          <div class="row text-center" style="margin-top: 2%;"
          *ngIf="(trainingData.finalScore!=null && trainingData.finalScore!='') || scoreperc!=null">
          <span style="color: gray;font-weight: 500;"><i><span *ngIf="isWithScoreTemplate">with score of
                {{trainingData.finalScore != null ? trainingData.finalScore : scoreperc}}% </span> on</i></span>
        </div>
          <div class="row text-center" style="margin-top: 2%;">
            <span style="font-weight: 600;">{{trainingData.completedOn | date:'dd-MMM-yyyy HH:mm:ss'}}</span>
          </div>
          <hr style="border-top: 3px solid black;">
          <div class="row" *ngIf="isEsignRequired">
          <span style="color: gray;font-weight: 500;"><i>{{trainingData.reasonForSignature == null ? reasonForSign : trainingData.reasonForSignature}}
            </i></span>
        </div>
          <div class="row" style="text-align: right;font-size: 11px;font-weight: 600;" *ngIf="isEsignRequired">
            <span>{{userDetails.userNameAtApplication}}</span>
            <span>{{userDetails.designation}}</span>
            <span>{{trainingData.completedOn | date:'dd-MMM-yyyy HH:mm:ss'}}</span>
            <span>I have read and understood training</span>
          </div>
        </div>
        <div class="col-md-2"
          style="height: auto;background-color: #f3caaf;width:13%;margin-top: 2%;margin-bottom: 2%;">

        </div>
      </div>
      <div id="dataToExportFromTemp" *ngIf="isDefaultTemplate" [innerHTML]="certificateData"></div>
    </div>
  </ng-template>

  <ng-template #closeOfLaunchPage>
    <div class="page-loading-shade" >
      <app-custom-spinner ></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="okConfirmation()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Confirmation</label>
      <label class="popupAppTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <div>
      <div class="form-continer">
        <div class="row">
          <div class="col-md-12">
            <div id="filed-container" class="form-continer" style="height: auto">
              <div class="row">
                <span>Please click on complete to close the training.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="button-continer" mat-dialog-actions class="btn-align">
        <button mat-stroked-button class="addButton" (click)="okConfirmation()">
          OK
        </button>
      </div>
    </div>
  </ng-template>
  <ng-template #notificationPopup>
    <button class="close close-button" (click)="cancelNotificationPopup()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Notifications</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="myTrainingLeftPlace" style="height: auto;max-height: 600px;overflow-y: auto;overflow-x: hidden;">
      <app-activity-notifications></app-activity-notifications>
    </div>
  </ng-template>

  <ng-template #certificationPopup1>
    <div class="ng-template-container hidden-popup" style="background-color: #f9f7f2;">
      <i class="fa fa-close pull-right" style="cursor: pointer;" title="Close" (click)="cancelCer()"></i>
      <i class="fa fa-download pull-right" style="cursor: pointer;" title="Download" (click)="downloadAsPdf()"></i>
      <div id="dataToExport" class="row" *ngIf="!isDefaultTemplate">
        <div class="col-md-10" style="margin-top: 2%;padding-left: 4%;margin-bottom: 2%;">
          <div class="row text-center">
            <span>
              <img *ngIf="oneQmsOrgImagesDetails.logoImage != null" class="org-image"
                src="data:image/*;base64,{{oneQmsOrgImagesDetails.logoImage}}" style="width: 60px;height: 60px;">
              <span style="display: inline-flex;width: 40%;">{{orgData.orgLongName}}</span>
            </span>
          </div>
          <br>
          <div class="row text-center">
            <span class="cetificateTitle">Certificate of Completion</span>

          </div>
          <div class="row text-center" style="margin-top: 2%;">
            <span style="color: gray;font-weight: 500;"><i>This is to certify that</i></span>
          </div>
          <div class="row text-center" style="margin-top: 2%;">
            <span style="font-weight: 600;">{{userDetails.userNameAtApplication}}</span>
          </div>
          <div class="row text-center" style="margin-top: 2%;">
            <span style="color: gray;font-weight: 500;"><i>Has successfully completed the {{trainingData.type}}
                course</i></span>
          </div>
          <div class="row text-center" style="margin-top: 2%;">
            <span style="font-weight: 600;">{{trainingData.trainingName}}</span>
          </div>
          <div class="row text-center" style="margin-top: 2%;"
            *ngIf="trainingData.finalScore!=null && trainingData.finalScore!=''">
            <span style="color: gray;font-weight: 500;"><i><span *ngIf="isWithScoreTemplate">with score of
                  {{trainingData.finalScore}}% </span> on</i></span>
          </div>
          <div class="row text-center" style="margin-top: 2%;">
            <span style="font-weight: 600;">{{trainingData.completedOn | date:'dd-MMM-yyyy HH:mm:ss'}}</span>
          </div>
          <hr style="border-top: 3px solid black;">
          <div class="row" *ngIf="isEsignRequired">
          <span style="color: gray;font-weight: 500;"><i>{{trainingData.reasonForSignature == null ? reasonForSign : trainingData.reasonForSignature}}
            </i></span>
        </div>
          <div class="row" style="text-align: right;font-size: 11px;font-weight: 600;" *ngIf="isEsignRequired">
            <span>{{userDetails.userNameAtApplication}}</span>
            <span>{{userDetails.designation}}</span>
            <span>{{trainingData.completedOn | date:'dd-MMM-yyyy HH:mm:ss'}}</span>
            <span>I have read and understood training</span>
          </div>
        </div>
        <div class="col-md-2"
          style="height: auto;background-color: #f3caaf;width:13%;margin-top: 2%;margin-bottom: 2%;">

        </div>
      </div>
      <div id="dataToExportFromTemp" *ngIf="isDefaultTemplate" [innerHTML]="certificateData"></div>
    </div>
  </ng-template>
</div>